var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "embroideryModal",
    attrs: {
      "cta-secondary-button": "personalizeRemove",
      "modal-name": "newEmbroideryModal",
      "widthModal": "92%",
      "headerTitle": _vm.translations.embroideryModalTitle,
      "click-to-close": false,
      "cta-primary-button": _vm.ctaButtons[_vm.componentName],
      "disable-buttons": _vm.disableButtons
    },
    on: {
      "before-open": _vm.beforeOpenModal,
      "cta-action": function ctaAction($event) {
        _vm.$refs.content.ctaAction ? _vm.$refs.content.ctaAction() : _vm.$modal.hide('embroideryModal');
      },
      "cta-secondary-action": _vm.removePersonalization,
      "go-back": function goBack($event) {
        _vm.$refs.content.goBackAction ? _vm.$refs.content.goBackAction() : _vm.$modal.hide('embroideryModal');
      },
      "closed": _vm.closeModal
    }
  }, [_c(_vm.componentName, {
    ref: "content",
    tag: "component",
    on: {
      "showBackButton": _vm.showBackButton,
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton,
      "disableButtons": _vm.setDisableButtons
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }